import React, { useEffect, useState } from "react";
import PaymentInquiry from "../component/PaymentInquiry";
import { Apinames } from "../utils/Apiname";
import {
  getBillingService,
  UpdateSubscriptionService,
} from "../services/BillingService";
import { getCookie } from "../utils/Common";

let role = "";
const PaymentInquirieScreen = () => {
  const [mainLoading, setMainLoading] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [subList, setSubList] = useState<any[]>([]);
  const [amountInputs, setAmountInputs] = useState<string[]>([]);
  const [platformFeeInputs, setPlatformFeeInputs] = useState<string[]>([]);

  useEffect(() => {
    const cookie: any = getCookie("data");
    role = cookie.role || null;
    getSubscriptionlist();
  }, []);

  const getSubscriptionlist = async () => {
    try {
      let endpoint = `${Apinames.usersGetSubscriptions}`;
      const response = await getBillingService(endpoint);

      if (response?.result) {
        setSubList(response?.result);
      }
    } catch (error) {
      console.error("Error fetching notifications:: ", error);
    } finally {
      setMainLoading(false);
    }
  };

  const UpdateUserSubscription = async (
    userId: number,
    amount: number,
    platform: number
  ) => {
    try {
      setIsLoading(true);
      let endpoint = `${Apinames.UpdateUserSubscription}`;
      let data = {
        userId: userId,
        amount: amount,
        platformFee: platform,
      };
      const response = await UpdateSubscriptionService(endpoint, data);

      if (response?.result) {
        getSubscriptionlist();
        setAmountInputs([]);
        setPlatformFeeInputs([]);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setMainLoading(false);
      setIsLoading(false);
    }
  };
  return (
    <PaymentInquiry
      mainLoading={mainLoading}
      subList={subList}
      UpdateUserSubscription={UpdateUserSubscription}
      role={role}
      setAmountInputs={setAmountInputs}
      setPlatformFeeInputs={setPlatformFeeInputs}
      platformFeeInputs={platformFeeInputs}
      amountInputs={amountInputs}
      isLoading={isLoading}
    />
  );
};

export default PaymentInquirieScreen;
